import styled from 'styled-components';

export const DialogOverlay = styled.div<{ open: boolean }>`
  display: ${(props) => (props.open ? 'block' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 999;

  dialog {
    position: relative;
  }

  label {
    font-size: 0.875rem !important;
  }

  input {
    border: 2px solid darkgrey;
    height: 0.875rem;
    font-size: 0.875rem;
  }
`;

export const Container = styled.div`
  overflow-y: auto;
  top: 0;
  left: 0;
  height: calc(80vh - 5rem);

  h4 {
    margin-block: 0.5rem 1rem;
  }
`;

export const ButtonWrapper = styled.div<{ bgWrapper: string }>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid grey;
  background-color: ${(props) => props.bgWrapper};
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;

  button {
    width: calc(100% - 1rem);
    margin: 0.5rem;
  }
`;

export const CloseWrapper = styled.div`
  position: absolute;
  top: 18px;
  right: 18px;
  cursor: pointer;

  img {
    width: 32px;
    height: 32px;
  }
`;

export const SettingsContainer = styled.div`
  border: 1px solid #c2c0c0;
  background-color: whitesmoke;
  padding: 0.5rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
`;
